import React, { useState } from "react";
import Category from "./components/Category";
import AddWidgetModal from "./components/AddWidgetModal";
import { useDashboard } from "./store/useDashboard";
import "./App.css";

const NAV_ITEMS = [
  { icon: "⊞", label: "Dashboard", active: true },
  { icon: "🛡", label: "CSPM" },
  { icon: "☁", label: "CWPP" },
  { icon: "🔍", label: "Registry Scan" },
  { icon: "🔔", label: "Alerts" },
  { icon: "📊", label: "Reports" },
  { icon: "⚙", label: "Settings" },
];

export default function App() {
  const { dashboard, addWidget, removeWidget } = useDashboard();
  const [showGlobalModal, setShowGlobalModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [timeFilter, setTimeFilter] = useState("Last 2 days");
  const [activeNav, setActiveNav] = useState("Dashboard");
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = () => {
    setRefreshing(true);
    setTimeout(() => setRefreshing(false), 1000);
  };

  const totalWidgets = dashboard.categories.reduce((sum, cat) => sum + cat.widgets.length, 0);
  const totalCategories = dashboard.categories.length;

  return (
    <div className={`app-shell ${sidebarOpen ? "sidebar-open" : "sidebar-collapsed"}`}>
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-icon"><span>C</span></div>
          {sidebarOpen && <span className="logo-text">CNAPP<strong>Guard</strong></span>}
        </div>

        <nav className="sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.label}
              className={`nav-item ${activeNav === item.label ? "nav-active" : ""}`}
              onClick={() => setActiveNav(item.label)}
              title={!sidebarOpen ? item.label : ""}
            >
              <span className="nav-icon">{item.icon}</span>
              {sidebarOpen && <span className="nav-label">{item.label}</span>}
            </button>
          ))}
        </nav>

        <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? "◀" : "▶"}
        </button>
      </aside>

      {/* Main Area */}
      <div className="main-area">
        {/* Topbar */}
        <header className="topbar">
          <div className="topbar-left">
            <div className="topbar-breadcrumb">
              <span className="breadcrumb-home">Home</span>
              <span className="breadcrumb-sep">›</span>
              <span className="breadcrumb-current">Dashboard V2</span>
            </div>
          </div>
          <div className="topbar-center">
            <div className="search-wrapper">
              <span className="search-icon">🔍</span>
              <input className="topbar-search" placeholder="Search widgets, alerts, resources..." />
            </div>
          </div>
          <div className="topbar-right">
            <button className="topbar-btn" title="Notifications">
              <span>🔔</span>
              <span className="notif-badge">3</span>
            </button>
            <button className="topbar-btn" title="Help">❓</button>
            <div className="topbar-user">
              <div className="user-avatar">A</div>
              <div className="user-info">
                <span className="user-name">Admin</span>
                <span className="user-role">Security Manager</span>
              </div>
            </div>
          </div>
        </header>

        {/* Dashboard Content */}
        <main className="main-content">
          {/* Dashboard Title Bar */}
          <div className="dashboard-titlebar">
            <div>
              <h2 className="dashboard-title">CNAPP Dashboard</h2>
              <p className="dashboard-subtitle">
                {totalCategories} categories · {totalWidgets} widgets active
              </p>
            </div>
            <div className="dashboard-controls">
              <button className="btn-add-widget" onClick={() => setShowGlobalModal(true)}>
                <span>+</span> Add Widget
              </button>
              <button className={`btn-icon ${refreshing ? "spinning" : ""}`} title="Refresh" onClick={handleRefresh}>
                ↻
              </button>
              <select className="time-filter" value={timeFilter} onChange={(e) => setTimeFilter(e.target.value)}>
                <option>Last 2 days</option>
                <option>Last 7 days</option>
                <option>Last 30 days</option>
              </select>
            </div>
          </div>

          {/* Summary Stats Bar */}
          <div className="stats-bar">
            <div className="stat-card stat-critical">
              <div className="stat-icon">⚠</div>
              <div className="stat-info">
                <span className="stat-value">1,698</span>
                <span className="stat-label">Critical Issues</span>
              </div>
            </div>
            <div className="stat-card stat-warning">
              <div className="stat-icon">⚡</div>
              <div className="stat-info">
                <span className="stat-value">681</span>
                <span className="stat-label">Warnings</span>
              </div>
            </div>
            <div className="stat-card stat-passed">
              <div className="stat-icon">✓</div>
              <div className="stat-info">
                <span className="stat-value">7,253</span>
                <span className="stat-label">Passed Checks</span>
              </div>
            </div>
            <div className="stat-card stat-accounts">
              <div className="stat-icon">☁</div>
              <div className="stat-info">
                <span className="stat-value">4</span>
                <span className="stat-label">Cloud Accounts</span>
              </div>
            </div>
          </div>

          {/* Categories */}
          {dashboard.categories.map((category) => (
            <Category
              key={category.id}
              category={category}
              allCategories={dashboard.categories}
              onAdd={addWidget}
              onRemove={removeWidget}
            />
          ))}
        </main>
      </div>

      {/* Global Add Widget Modal */}
      {showGlobalModal && (
        <AddWidgetModal
          category={dashboard.categories[0]}
          allCategories={dashboard.categories}
          onAdd={addWidget}
          onRemove={removeWidget}
          onClose={() => setShowGlobalModal(false)}
        />
      )}
    </div>
  );
}
